export default function ValidationsItemProcesso() {

    const validateFields = (fields) => {
        const {
            servico,
            tipo,
            nomeProcesso,
            nomeItem,
            descricao,
        } = fields;
        const errors = {};
        
        if (!servico || !servico.value) {
            errors.servico = "Pelo menos um serviço deve ser selecionado.";
        }
        if (!tipo || !tipo.value) {
            errors.tipo = "Pelo menos um tipo deve ser selecionado.";
        }
        if (!nomeProcesso || !nomeProcesso.value) {
            errors.nomeProcesso = "Pelo menos um processo deve ser selecionado.";
        }
        if (!nomeItem || !nomeItem.trim()) {
            errors.nomeItem = "O campo Item do Processo é obrigatório.";
        }
        if (!descricao || !descricao.trim()) {
            errors.descricao = "O campo Descrição é obrigatório.";
        }
       
        return errors;
    };

    return {
        validateFields
    };
}
